import { localeSelector } from '@/domain/env';

import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/locale-data/en';
import '@formatjs/intl-pluralrules/locale-data/he';
import '@formatjs/intl-pluralrules/locale-data/es';
import '@formatjs/intl-pluralrules/locale-data/it';
import '@formatjs/intl-pluralrules/locale-data/fr';

const TRANSLATION = {
  en: () => import('@/translation/en'),
  uk: () => import('@/translation/en'),
  he: () => import('@/translation/he'),
  es: () => import('@/translation/es'),
  it: () => import('@/translation/it'),
  fr: () => import('@/translation/fr'),
};

export default function intl(store) {
  const locale = localeSelector(store.getState());
  return Promise.all([TRANSLATION[locale]()]).then((res) => ({ locale, translation: res[0].default }));
}
